<div class="portal-bg" [ngStyle]="{'background-image': hasLoginBackground? 'url(' + logosObj.loginBackgroundImg + ')': ''}">
  <div class="background_layout__overlay"  [ngStyle]="{'background-color': logosObj.loginBackgroundColor, 'opacity': logosObj.opacity}"  *ngIf="hasLoginBackground"></div>
  <ng-template [ngIf]="showLoginPage">
    <div class="login-form-cotainer row" [hidden]="isLoginByToken"
         [ngClass]="{'loginWithBg': hasLoginBackground}">
      <div class="column small-12 medium-6 login-desc" *ngIf="hasLoginBackground">
        <h3 class="title" style="color: #FFF;">{{logosObj.loginBackgroundText}}</h3>
        <div class="desc">{{logosObj.loginBackgroundDescription}}</div>
      </div>
      <div class="column small-12 medium-centered" [ngClass]="{'medium-6 large-5' : !hasLoginBackground, 'medium-4 large-4' : hasLoginBackground}">
        <div class="form">
          <header>
            <div class="logo" [ngStyle]="logoBg">
            </div>
          </header>
          <div *ngIf="fpStatus" class="formstatus">
            <span [ngClass]="{'success': fpStatus?.success, 'error': fpStatus?.error}">{{fpMessage}}</span>
          </div>
          <form *ngIf="active" [formGroup]="loginForm">
            <div *ngIf="status" class="formstatus">
              <span [ngClass]="{'success': status.success, 'error': status.error}">{{message}}</span>
            </div>
            <div class="row" style="font-family: Poppins-Regular;">
              <div class="small-12 columns">
                <input formControlName="id" type="text" placeholder="Email *">
                <div class="error text-center" [hidden]="loginForm.get('id').untouched || loginForm.get('id').valid">
                  <small>Please enter valid email address.</small>
                </div>
              </div>
              <div class="small-12 columns ">
                <input formControlName="password" type="password" placeholder="Password *">
                <div class="error text-center" [hidden]="loginForm.get('password').untouched || loginForm.get('password').valid">
                  <small>Please enter password.</small>
                </div>
              </div>
              <div class="small-12 column">
                <input formControlName="rememberMe" id="rememberMe" type="checkbox"><label for="rememberMe">Remember Me</label>
              </div>
            </div>
            <div class="row align-middle">
              <div class="small-6 column">
                <button type="submit" class="button button-style custom-login" [disabled]="!checkValidity()"
                        [ngClass]="{'disabled' : !checkValidity()}" (click)="submit($event)">LOGIN
                </button>
              </div>
              <div class="small-6 column help-text-links">
                <a (click)="forgotPasswordPage()">Forgot your password?</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="login-form-cotainer row" style="font-family: Poppins-Regular;" *ngIf="isLoginByToken">
      <div class="column small-12 medium-6 login-desc" *ngIf="hasLoginBackground">
        <h3 class="title" style="color: #FFF;">{{logosObj.loginBackgroundText}}</h3>
        <div class="desc">{{logosObj.loginBackgroundDescription}}</div>
      </div>
      <div class="column small-12 medium-centered" [ngClass]="{'medium-6 large-5' : !hasLoginBackground, 'medium-4 large-4' : hasLoginBackground}">
        Logging you in as customer
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="showForgotPasswordPage">
    <div class="login-form-cotainer row"  [ngClass]="{'loginWithBg':hasLoginBackground}">
      <div class="column small-12 medium-6 login-desc" *ngIf="hasLoginBackground">
        <h3 class="title" style="color: #FFF;">{{logosObj.loginBackgroundText}}</h3>
        <div class="desc">{{logosObj.loginBackgroundDescription}}</div>
      </div>
      <div class="column small-12 medium-centered" [ngClass]="{'medium-6 large-5' : !hasLoginBackground, 'medium-4 large-4' : hasLoginBackground}">
        <div class="form" style="font-family: Poppins-Regular;">
          <form (ngSubmit)="changePassword($event)" [formGroup]="forgotPasswordForm">
            <header>
              <div class="logo" [ngStyle]="logoBg">
              </div>
              <h6 style="font-family: Poppins-Regular;">Not to worry. Enter your email below and we'll send you instructions on how to reset your password.</h6>
            </header>

            <div class="row">
              <div class="small-12 columns" style="font-family: Poppins-Regular;">
                <input formControlName="id" type="text" placeholder="Email *"
                       pattern="[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$">
                <div class="error text-center"
                     [hidden]="forgotPasswordForm.get('id').untouched || forgotPasswordForm.get('id').valid">
                  <small>Enter a valid email address.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="small-12 column">
                <button type="submit" class="button-style button button-style custom-login" [disabled]="!checkForgotPasswordValidity()"
                        [ngClass]="{'disabled' : !checkForgotPasswordValidity()}" (click)="changePassword($event)">SEND
                </button>
              </div>
            </div>
            <div class="row">
              <div class="small-12 column footer">
                <a (click)="loginPage()"><i class="ion-android-arrow-back"></i> Back to Login</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="reveal['showPopup']">
      <div class="reveal-overlay" [ngClass]="{'qount-reveal': reveal['showPopup']}">
      </div>
      <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 30%;" [ngClass]="{'qount-reveal': reveal['showPopup']}">
        <div class="body reveal-publish strategy-reveal-confirm" style="padding: 15px;">
          <div class="row row-padding-reveal">
            <div class="small-12 medium-12">
              <span>  If you are a valid user, an email should appear in your inbox within a few minutes with instructions to reset your password. Please also check your spam, junk or quarantine folders for this email.</span>
            </div>
          </div>
          <div class="row row-padding-reveal float-right">
            <button class="button small" (click)="closePopup()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template>
    <div class="login-form-cotainer row">
      <div class="column small-12 medium-6 login-desc" *ngIf="hasLoginBackground">
        <h3 class="title" style="color: #FFF;">{{logosObj.loginBackgroundText}}</h3>
        <div class="desc">{{logosObj.loginBackgroundDescription}}</div>
      </div>
      <div class="column   small-12 medium-centered" [ngClass]="{'medium-6 large-5' : !hasLoginBackground, 'medium-4 large-4' : hasLoginBackground}">
        <div class="form" style="font-family: Poppins-Regular;">
          <div class="heading">Reset Password</div>
          <div class="row">
            <div class="small-12 columns">
              <input id="resetPassword" type="password" placeholder="Password">
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <input id="resetPasswordConfirmation" type="password" placeholder="PasswordConfirmation">
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns input-group">
              <a class="button" (click)="resetPassword()">Reset password</a>
            </div>
          </div>
          <div *ngIf="fpStatus" class="formstatus">
            <span [ngClass]="{'success': fpStatus?.success, 'error': fpStatus?.error}">{{fpMessage}}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
